import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
import { NeoFuenteFiltroDTO } from 'src/app/comun/models/NeoFuenteFiltroDTO';
@Injectable({
  providedIn: 'root',
})
export class MicroempresarioService {
  microempesarioEnd: string = `${environment.apiLocalUrl}microempresario/servicios`;
  archivosaws = `${environment.apiLocalUrl}comun/servicios`;
  listadoSisben = `${environment.apiLocalUrl}sisben/servicios`;
  constructor(private http: HttpClient) {}

  //Peticiones POST
  savePersonaNatural(naturalForm: any) {
    return this.http.post(`${this.microempesarioEnd}/registroNatural`, naturalForm
    ).pipe(catchError(HandleHttpError));
  }

  savePersonaJuridica(juridicaForm: any) {
    return this.http.post(
      `${this.microempesarioEnd}/registroJuridico`, juridicaForm
    ).pipe(catchError(HandleHttpError));
  }

  validateCod(otpBody: any) {
    return this.http.post(
      `${this.microempesarioEnd}/validacionRegistro`, otpBody).pipe(catchError(HandleHttpError));
  }

  login(loginBody: any) {
    return this.http
      .post(`${this.microempesarioEnd}/ingreso`, loginBody).pipe(catchError(HandleHttpError)).toPromise();
  }

  saveSolicitud(endpoint: string, body: any) {
    return this.http.post(
      `${this.microempesarioEnd}/guardarDatos/${endpoint}`, body).pipe(catchError(HandleHttpError));
  }

  cargarDatos(body: any) {
    return this.http.post(`${this.microempesarioEnd}/cargarDatos`, body).pipe(catchError(HandleHttpError));
  }

  negarPropuesta(body: any) {
    return this.http.post(
      `${this.microempesarioEnd}/registroNegarPropuestas`, body).pipe(catchError(HandleHttpError));
  }

  //Peticiones GET
  getSolicitudes(idEmpresario: number) {
    return this.http.get(
      `${this.microempesarioEnd}/solicitudesCredito/${idEmpresario}`).pipe(catchError(HandleHttpError));
  }

  getPropuestas(idSolicitud: string) {
    return this.http.get(`${this.microempesarioEnd}/propuestas/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }

  aceptarPropuesta(body: any) {
    return this.http.post(`${this.microempesarioEnd}/aceptarPropuesta/`, body).pipe(catchError(HandleHttpError));
  }

  cargarDatosRegistro(tipo: string, idUsuario: string) {
    return this.http.get(`${this.microempesarioEnd}/${tipo}/${idUsuario}`).pipe(catchError(HandleHttpError));
  }

  crearSolicitud(idSolicitud: string) {
    return this.http.get(
      `${this.microempesarioEnd}/crearSolicitud/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }

  saveFile(body: any) {
    return this.http.post(`${this.microempesarioEnd}/guardarArchivos`, body).pipe(catchError(HandleHttpError));
  }

  saveFileAWS(body: any) {
    return this.http.post(`${this.archivosaws}/envio-archivo-aws`, body).pipe(catchError(HandleHttpError));
  }

  getDocumentosAWS(idSolicitud: any) {
    return this.http.get(`${this.archivosaws}/obtener-archivos-aws/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }

  deleteFile(idDocumento: string) {
    return this.http.get(`${this.microempesarioEnd}/eliminarDocumento/${idDocumento}`).pipe(catchError(HandleHttpError));
  }

  deleteFileAWS(body: any) {
    return this.http.post(`${this.archivosaws}/eliminar-archivo-aws`, body).pipe(catchError(HandleHttpError));
  }

  downloadFile(idDocumento: string) {
    return this.http.get(
      `${this.microempesarioEnd}/descargarDocumento/${idDocumento}`
    ).pipe(catchError(HandleHttpError));
  }

  downloadAllFile(idSolicitud: string) {
    return this.http.get(
      `${environment.apiLocalUrl}neoSolicitudCredito/service/documentosSolicitud/${idSolicitud}`
    ).pipe(catchError(HandleHttpError));
  }

  getMensajeInformativo(tipoPersona: string) {
    return this.http.get(
      `${this.microempesarioEnd}/solicitud/mensajeInformativo/${tipoPersona}`
    ).pipe(catchError(HandleHttpError));
  }

  getSolicitudesAprobadas(idEmpresario: number, pagina: number) {
    return this.http.get(
      `${this.microempesarioEnd}/graficaAprobadas/${idEmpresario}/${pagina}`
    ).pipe(catchError(HandleHttpError));
  }

  getGraficaEstados(idEmpresario: number) {
    return this.http.get(
      `${this.microempesarioEnd}/graficaEstados/${idEmpresario}`
    ).pipe(catchError(HandleHttpError));
  }

  getIntermediarioAproboSolicitud(idSolicitud: String) {
    return this.http.get(
      `${this.microempesarioEnd}/intermediarioAproboSolicitud/${idSolicitud}`
    ).pipe(catchError(HandleHttpError));
  }

  cargarDatosPersonaNatural() {
    return this.http.get(`${this.microempesarioEnd}/cargarDatosNatural`).pipe(catchError(HandleHttpError));
  }

  cargarDatosPersonaJuridica() {
    return this.http.get(`${this.microempesarioEnd}/cargarDatosJuridica`).pipe(catchError(HandleHttpError));
  }

  updatePersonaNatural(naturalForm: any) {
    return this.http.post(
      `${this.microempesarioEnd}/updatePersonaNatural`, naturalForm).pipe(catchError(HandleHttpError));
  }

  updatePersonaJuridico(juridicaForm: any) {
    return this.http.post(
      `${this.microempesarioEnd}/updatePersonaJuridico`, juridicaForm).pipe(catchError(HandleHttpError));
  }

  getFinalizarSolicitud(idSolicitud: any) {
    return this.http.get(
      `${this.microempesarioEnd}/finalizarSolicitud/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }

  validarRestricciones(idEmpresario: number) {
    return this.http.get(
      `${this.microempesarioEnd}/validarRestriccionCrearSolicitud/${idEmpresario}`
    ).pipe(catchError(HandleHttpError));
  }

  cerrarSolicitudMicroempresario(body:any){
    return this.http.put(
      `${this.microempesarioEnd}/cancelarSolicitudCredito`,body
    ).pipe(catchError(HandleHttpError));
  }

  //Cargue de campañas
  cargarRegistroJuridico(body: any){
    return this.http.post(`${this.microempesarioEnd}/consultarInformacionCampania/personaJuridica`, body).pipe(catchError(HandleHttpError));
  }

  cargarRegistroNatural(body: any){
    return this.http.post(`${this.microempesarioEnd}/consultarInformacionCampania/personaNatural`, body).pipe(catchError(HandleHttpError));
  }

  // Como se entero de neo

  getFuentes(filtro: NeoFuenteFiltroDTO){
    return this.http.post(
      `${this.microempesarioEnd}/Fuente/obtenerFuente`, filtro
    ).pipe(catchError(HandleHttpError));

  }

  // Porcentaje Solicitud en Proceso
  getPorcentajeSolicitudProceso(tipoPersona:any,idEmpresario:any){
    return this.http.get(
      `${this.microempesarioEnd}/solicitud/porcentaje/${tipoPersona}/${idEmpresario}`)
      .pipe(catchError(HandleHttpError));
  }

  // listado sisben
  getClasificacionSisben(){
    return this.http.get(
      `${this.listadoSisben}/listarSisben`)
      .pipe(catchError(HandleHttpError));
  }

  //Listado tipo contacto
  getListaTipoContacto(){
    return this.http.get(`${environment.apiLocalUrl}neoTipoContacto/servicios/habilitados`).pipe(catchError(HandleHttpError));
  }

  //Validación obligatorios registro
  getValidarRegistroNatural(idEmpresarioNatural:any, idEmpresario: any){
    return this.http.get(`${this.microempesarioEnd}/updatePersonaNatural/validacion/${idEmpresarioNatural}/${idEmpresario}`).pipe(catchError(HandleHttpError));
  }

  getValidarRegistroJuridico(idEmpresario: any){
    return this.http.get(`${this.microempesarioEnd}/updatePersonaJuridico/validacion/${idEmpresario}`).pipe(catchError(HandleHttpError));
  }

  //Guardar observaciones microempresario
  guardarObservacionesMicro(body: any){
    return this.http.put(`${environment.apiLocalUrl}neoSolicitudCredito/service/observacionesMicro`, body).pipe(catchError(HandleHttpError));
  }

  getObservacionesMicro(idSolicitud: any){
    return this.http.get(`${environment.apiLocalUrl}neoSolicitudCredito/service/observacionesMicro/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }

  putNotificaciones(body: any){
    return this.http.put(`${this.microempesarioEnd}/habilitarNotificaciones`, body).pipe(catchError(HandleHttpError));
  }

  //Documentos segmentos
  getDocumentosBySegmento(idSolicitud: any){
    return this.http.get(`${this.microempesarioEnd}/tipoDocumentosSegmento/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }

  saveFileSegmento(body: any) {
    return this.http.post(`${this.microempesarioEnd}/guardarArchivosSegmento`, body).pipe(catchError(HandleHttpError));
  }

  getDocumentosBySolicitudAndSegmento(IdSegmento: any, idSolicitud: any){
    return this.http.get(`${this.microempesarioEnd}/buscarDocumentosSegmento/${IdSegmento}/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }
  
  getDocumentoSegmento(idSolicitud: any) {
    return this.http.get(`${this.microempesarioEnd}/buscarDocumentosSegmento/${idSolicitud}`).pipe(catchError(HandleHttpError));
  }

  deleteFileSegmento(idDocumentoSegmento: string) {
    return this.http.get(`${this.microempesarioEnd}/eliminarDocumentoSegmento/${idDocumentoSegmento}`).pipe(catchError(HandleHttpError));
  }

  downloadFileSegmento(idDocumentoSegmento: string) {
    return this.http.get(
      `${this.microempesarioEnd}/descargarDocumentoSegmento/${idDocumentoSegmento}`
    ).pipe(catchError(HandleHttpError));
  }
}
